import styles from './Header.module.css'
import buttonStyle from '../CSS/ButtonGroup.module.css'
import mainLogo from '../Img/Logo/logo.png'
import beeLogo from '../Img/Logo/beeLogo.png'

import icHome from '../Img/Menu/Bottom/icHome.png'
import icLk from '../Img/Menu/Bottom/icLk.png'
import icFilter from '../Img/Menu/Bottom/icFilter.png'
import icRegion from '../Img/Menu/Bottom/icRegion.png'
import React, {useEffect, useRef, useState} from "react";
import useApiQuery, {ApiQueryResponse} from "../ApiQuery/UseApiQuery";
import {useLocation, useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {
    ReduxStateInt, sendActionMessage,
    setAuthLogin,
    setAuthToken,
    setBaseRegion,
    setLoginState,
    setSlider, setTfFilter, setXFilterValue
} from "../Reducer/GlobalReducer";
import SellStage from "../SellStage/SellStage";
import iconLK from "../Img/icon_lk.png";
import iconGeo from "../Img/icon_geo.png";
import b3 from "../Img/banner/banner_5.jpg";
import useApiQueryBundle from "../ApiQuery/UseApiQueryBundle";
function Header()
{

    const [logo,setLogo] = useState('')

    const prefDomain = useSelector((state: ReduxStateInt) => {
        return state.prefDomain
    })

    const showStickedMenu =useSelector((state:ReduxStateInt)  => {return state.showStickedMenu})

    const mainFilterActive = useSelector((state: ReduxStateInt) => {
        return state.tarifFilter?.active
    })

    const navigate = useNavigate();
    const data = useRef({name:"Hello", id:[]})
    const tfFilter = useSelector((state:ReduxStateInt)  => {return state.tarifFilter} )
    const xfFilter = useSelector((state:ReduxStateInt)  => {return state.xFilter} )

    const mockData = useRef(null)
    const [ldrLogout,rsLogout,exLogout] = useApiQuery("/auth/logout","get",mockData,cbLogout);
    const isRegionChanged = useSelector((state:ReduxStateInt)  => {return state.baseRegion.isChanged})
    const baseRegion = useSelector((state:ReduxStateInt)  => {return state.baseRegion});

    const [ldrUsCount, exUsCount] =useApiQueryBundle.useApiQueryPost("/ref/count", useRef(null))
    const [usCount, setUsCount] = useState(-1)

    const [activeFilterButton, setActiveFilterButton] = useState(false)

    const location = useLocation()
    const mobileMode = useSelector((state: ReduxStateInt) => {
        return state.mobileMode
    })

    const prefUser = useSelector((state:ReduxStateInt)  => {return state.prefUser})

    const rxObserve = useSelector((state: ReduxStateInt) => {
        return state.rxObserve
    })

    const [slogan, setSlogan] = useState<any>(null)

    const isLogin =  useSelector((state:ReduxStateInt)  => {return state.isLogin})
    const authUser =  useSelector((state:ReduxStateInt)  => {return state.authLogin})

    const onRec = (dt: any)=>{
        console.log("executed", dt)

    }
    const dispatch = useDispatch()

    useEffect(()=>{

        switch (prefDomain?.mainLogo){
            case 'beeLogo':
                setLogo(beeLogo)
                break

            default: setLogo(mainLogo)
        }


    },[prefDomain?.mainLogo])



    useEffect(()=>{
//        console.log("location", location?.pathname)
        if(location?.pathname === '/')setActiveFilterButton(true)
        else setActiveFilterButton(false)

    },[location])



    useEffect(()=>{
        loadUsCount()
    },[baseRegion])

    useEffect(()=>{
        //console.log("effect s", prefDomain)
        if(!prefDomain || prefDomain.stillLoad) return
        try {
            const x = prefDomain?.slogan ?  prefDomain?.slogan : prefDomain.slogan
            setSlogan(x)

        } catch (e) {
            setSlogan(prefDomain?.slogan)
        }

    },[prefDomain])

    useEffect(()=>{
        //run().then((e:any)=>{console.log(e)})
    },[])

    const loadUsCount = () =>{
        exUsCount().then((e)=>{
            if(e?.success)
            {
                setUsCount(e?.payload)
                return
            }
        })
    }

    function cbLogout(payload:ApiQueryResponse){
        if(payload.success || true)
        {
            dispatch(setAuthToken(""))
            dispatch(setAuthLogin(null))
            dispatch(setLoginState(false))
            navigate('/')
        }
    }


    const moveHome = () =>{

        //dispatch(sendActionMessage("hello"))
        rxObserve.next({
            message: "mainMenu-home"
        })
        dispatch(setSlider({sliderMode:0}));
        dispatch(setTfFilter({...tfFilter,active: false}))
        dispatch(setXFilterValue({...xfFilter,active: false,val:""}))
        navigate('/')
        window.scrollTo({
            top:0
        })

    }
    const lkMake=() =>{
        if(isLogin)exLogout().then()
        else navigate('/auth')
    }


    const buildLK = () =>{
        return(

            <>

                {!mobileMode &&
                    <div className={styles.lkContMain}>
                        <div className={[styles.baseOption, styles.lk,styles.plBox].join(' ')} onClick={()=>navigate('/auth')}>

                            <div className={styles.lineCont}>
                                <div>
                                    <img src={iconLK}></img>
                                </div>
                                <span>личный кабинет <span className={styles.lkText}>{isLogin ? '[ ' + authUser + ' ]' : ""}</span></span>
                                <div className={buttonStyle.btnCont}>
                                    <button type="button" className={["btn btn-secondary", styles.rnBtn].join(' ')}
                                            onClick={()=>lkMake()}
                                    >
                                        {!isLogin ? "Войти" : "Выйти"}
                                    </button>
                                </div>


                            </div>

                        </div>

                    </div>

                }

                { mobileMode && showStickedMenu &&
                    <div className={[styles.fxMenu,""].join(' ')}>
                        <div className={styles.icCont}
                             onClick={()=>moveHome()}
                        >
                            <img src={icHome}/>
                            <div className={styles.mnTitle}>Главная</div>
                        </div>

                        <div className={styles.icCont}
                             onClick={()=>
                                 dispatch(setBaseRegion({makeSelectRegion:true}))
                        }
                        >
                            <img src={icRegion}/>
                            <div className={styles.mnTitle}>Регион</div>
                        </div>



                        <div className={[styles.icCont, activeFilterButton ? "" : styles?.opHalf].join(' ')}
                            onClick={()=>{
                                if(!activeFilterButton) return
                                rxObserve.next({
                                    message: "btMenu-filter"
                                })
                                rxObserve.next({
                                    message: "mainFilter-view"
                                })


                            }}

                        >
                            <img src={icFilter} className={[!mainFilterActive ? styles.opHalf : ""].join(' ')}/>
                            <div className={styles.mnTitle}>Фильтр</div>
                        </div>



                        <div className={styles.icCont}

                             onClick={()=>{
                                 if(isLogin) {
                                     navigate('/lk')
                                     return
                                 }
                                 lkMake()
                             }}
                        >
                            <img src={icLk} className={[!isLogin ? styles?.opHalf : ""].join(' ')}/>
                            <div className={styles.mnTitle}>{isLogin ? "ЛК" : "Войти"}</div>
                        </div>
                    </div>

                }



            </>

        )
    }


    const buildRegion = () =>{
        //pref
        if(! prefUser?.showRegionChange) return null

        const txt = isRegionChanged ? `[${baseRegion.macroRegionId}] ${baseRegion.regionName}` : "Где Вы"
        return (

            <div className={styles.rgContMain}>
                <div className={[styles.baseOption, styles.geo].join(' ')}
                     onClick={()=>{
                         //navigate('/region/change')
                         dispatch(setBaseRegion({makeSelectRegion:true}))
                     }}>
                    <div className={[styles.rgCont,isRegionChanged ? "d-none" : ""].join(' ')}>
                        <img src={iconGeo}></img>
                        <span className={isRegionChanged ? "" : styles.blink}>выберите регион:</span>

                    </div>
                    <div>
                        <span>{txt}</span>
                    </div>

                </div>

            </div>
        )
    }


    const buildUsCount = (mode = 0)=>{
        if(usCount < 0) return null
        if(mode === 0 )
            return(
                <div className={[styles.usSmall, styles.usSmallGradient].join(' ')}>
                    <div>нас уже<span>{usCount}</span>подключайся</div>
                </div>
            )
        if(mode === 1 )
            return(
                <div className={[styles.usSmall, styles.usSmallGradient].join(' ')}>
                    <div>Нас уже<span>{usCount}</span>- присоединяйся в сообщество</div>
                </div>
            )
        return null
    }

    return(

        <>
            <div className={[styles.mainCont, styles.header, styles.bigView].join(' ')}>

                <div className={styles.block5}>
                    <div className={styles.block4}>
                        <div className={["item-1"].join(' ')} onClick={()=>{
                            moveHome()
                        }}>
                            <img src={logo} className={styles.logo}/>
                        </div>
                        <div className={[styles.sloganDivider].join(' ')}></div>
                        <div className={["item-2"].join(' ')} >
                            <h4 className={[styles.slogan].join(' ')}>{slogan}</h4>
                        </div>

                    </div>
                    {buildRegion()}
                </div>


                <div className={styles.stCont}>
                    {buildUsCount(1)}
                    <SellStage/>

                </div>

                <div className={styles.block3}>
                    <div className={styles.block1}>
                        <div className={styles.item3}>
                            <p>Напишите нам</p>
                            <a className={[styles.email].join(' ')} href={"mailto:service@sim-unlim.com"}>service@sim-unlim.com</a>
                        </div>
                        <div className={styles.item4}>
                            <p>Позвоните нам</p>
                            <a className={[styles.phone].join(' ')} href={"tel:+79993046060"}>8-999-304-6060</a>
                        </div>
                    </div>
                    {buildLK()}
                </div>
            </div>




            <div className={[styles.mainCont, styles.header, styles.smallView].join(' ')}>

                <div className={styles.block5}>
                    {false && buildUsCount()}

                    <div className={styles.homeBut} onClick={()=>moveHome()}><i className='bx bx-home'></i></div>
                    <div className={styles.block4}>
                        <div className={["item-1"].join(' ')} onClick={()=>{moveHome()}}>
                            <img src={logo} className={styles.logo}/>
                        </div>
                        <div className={[styles.sloganDivider].join(' ')}></div>
                        <div className={["item-2"].join(' ')} >
                            <h4 className={[styles.slogan].join(' ')}>{slogan}</h4>
                        </div>

                    </div>
                    {buildUsCount()}
                    {buildRegion()}
                </div>


                <div className={styles.stCont}>
                    <SellStage/>

                </div>

                <div className={styles.block3}>
                    {buildLK()}
                </div>
            </div>
        </>

    );
}
export default Header;